import { type OnPageTransitionStartAsync } from 'vike/types';

export const onPageTransitionStart: OnPageTransitionStartAsync =
  async (): ReturnType<OnPageTransitionStartAsync> => {
    if (!globalThis.routerTransitionSubscribers) {
      return;
    }

    for (const subscriber of globalThis.routerTransitionSubscribers) {
      if (subscriber.onTransitionStart) {
        subscriber.onTransitionStart();
      }
    }

    document
      .querySelector('#page-transition-animation')
      ?.classList.add('page-transition-animation__active');

    document
      .querySelector('#page-transition-animation')
      ?.classList.remove('page-transition-animation__finished');
  };
